module.exports = __webpack_public_path__ + "static/media/newEditIcon.3843322e.svg";